/*
 * Base is the default environment for production.
 * Add everything here and override value in other files if needed.
 * https://blog.usejournal.com/my-awesome-custom-react-environment-variables-setup-8ebb0797d8ac
 */
export default function baseEnv(influencersAPI) {
  return {
    route: {
      baseRoute: "/react-redux-architecture", // Fixes issue with Github Pages
    },
    api: {
      baseApi: `${influencersAPI}`,

      login: `${influencersAPI}/v1/api/login`,
      // Logout api
      logout: `${influencersAPI}/v1/api/logout`,
      errorExample: "https://httpstat.us/520",

      // Influencers Campaigns
      influencersCampaign: `${influencersAPI}/influencer_campaign`,
      influencersCampaignFilter: `${influencersAPI}/influencer_campaign`,

      // Influencers Activity
      influencersActivity: `${influencersAPI}/influencer_activity`,
      influencersActivityFilter: `${influencersAPI}/influencer_activity`,

      // Influencer User
      influencerUser: `${influencersAPI}/influencer_user`,
      influencerUserFilter: `${influencersAPI}/influencer_user`,

      //Influencer dashboard
      influencerDashboard: `${influencersAPI}/manager_dashboard`,

      //Influencer Reports
      influencerReports: `${influencersAPI}/reports_on_influencer`,
      campaignReports: `${influencersAPI}/reports_on_campaign`,
      InfluencerAgentReports: `${influencersAPI}/reports_on_agent`,

      // admin Reset Password
      influencerAdminResetPassword: `${influencersAPI}/v1/api/influencer_admin_reset_password`,

      // user Reset Password
      influencerUserResetPassword: `${influencersAPI}/v1/api/influencer_user_reset_password`,

      // campaign mapping
      campaignMapping: `${influencersAPI}/influencer_campaign_mapping`,
      campaignMappingFilter: `${influencersAPI}/influencer_campaign_mapping`,

      // device mapping
      influencerDeviceMapping: `${influencersAPI}/influencer_device_mapping`,

      //influencer activity type
      activityType: `${influencersAPI}/influencer_activity_type`,

      // influencer platforms
      influencerPlatformAccounts: `${influencersAPI}/influencer_platform_accounts`,
      influencerFacebookPlatform: `${influencersAPI}/influencer_facebook_account`,
      influencerInstagramPlatform: `${influencersAPI}/influencer_instagram_account`,
      influencerYoutubePlatform: `${influencersAPI}/influencer_youtube_account`,
      influencerQuoraPlatform: `${influencersAPI}/influencer_quora_account`,
      influencerPlaystorePlatform: `${influencersAPI}/influencer_playstore_account`,
      influencerTwitterPlatform: `${influencersAPI}/influencer_twitter_account`,

      tag: `${influencersAPI}/tag`, //Tag Api
      category: `${influencersAPI}/category`, //category API
      platform: `${influencersAPI}/platform`,

      //status
      status: `${influencersAPI}/status`,
      statusFilter: `${influencersAPI}/status`,

      // custom fields
      custom_ticket_field: `${influencersAPI}/custom_ticket_fields`,

      // location
      location: `${influencersAPI}/influencer_location`,
    },
    isProduction: true,
    isDevelopment: false,
    isTesting: false,
  };
}
